// DateFormatter.ts
import {getI18n} from "react-i18next";
import dayjs from "dayjs";
import {resolveDayjsLocale} from "@/app/locale/muiLocale";

export type DateFormat = "date" | "date_hm" | "datetime";

/**
 * Time part appended to the localized date pattern for each format.
 */
const TIME_SUFFIX: Record<DateFormat, string> = {
    date: "",
    date_hm: " HH:mm",
    datetime: " HH:mm:ss"
};

/**
 * Last-resort date pattern should the resolved Day.js locale not be registered. `muiLocale.ts` loads every
 * locale it maps to, so this only guards against a broken coupling there.
 */
const FALLBACK_DATE_PATTERN = "DD.MM.YYYY";

/**
 * Returns the dayjs format pattern for the active UI language. The date part is the same `L` pattern
 * `formatIsoDate` and `formatDateTime` read, so a language has exactly one date layout, maintained in
 * `LANGUAGE_TO_DAYJS_LOCALE` (ADR-015). An unknown language falls back to German.
 */
export const DateFormatter = (format: DateFormat = "date"): string => {
    const locale = dayjs.Ls[resolveDayjsLocale(getI18n()?.language)];
    return (locale?.formats.L ?? FALLBACK_DATE_PATTERN) + TIME_SUFFIX[format];
};
